import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday"; // Plugin để xử lý ngày trong tuần
import isSameOrAfter from "dayjs/plugin/isSameOrAfter"; // Plugin để so sánh ngày
import isSameOrBefore from "dayjs/plugin/isSameOrBefore"; // Plugin để so sánh ngày
import localeData from "dayjs/plugin/localeData";

// Kích hoạt các plugin
dayjs.extend(weekday);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(localeData); 

export default dayjs; // Xuất dayjs đã cấu hình